import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ImmutablePropTypes from 'react-immutable-proptypes';

import PanelWithTitleAndIcon from '../../common/PanelWithTitleAndIcon';

import { HistoryItem } from '../MatchModel';
import tr, { mapIsoCodeToCountryName } from '../../localization/translate';

import firstTimeMoverIcon from '../../assets/images/first-time-mover.svg';
import rentalHistoryIcon from '../../assets/images/rentalhistory-icon.svg';
import './RentalHistory.scss';

const dateFormat = 'MMMM YYYY';

function title(asSharedProfile) {
  if (asSharedProfile) {
    return tr('simple_pages.share_profile.rental_history.title');
  }

  return tr('matching.rental_history.title');
}


function getToDate(to) {
  if (to.isAfter(moment.utc())) {
    return tr('matching.rental_history.now');
  }

  return to.format(dateFormat);
}

function getHistoryItems(firstTimeMover, list) {
  if (list.isEmpty()) {
    if (firstTimeMover) {
      return (
        <div styleName="first_time_mover">
          <img role="presentation" src={firstTimeMoverIcon} styleName="first_time_mover_icon" />
          <p className="heavy_text">{ tr('matching.rental_history.first_time_mover') }</p>
        </div>
      );
    }
    return (
      <p className="top_margin_20 heavy_text tall_lines">{ tr('matching.no_entry') }</p>
    );
  }

  return list.map(item => (
    <div styleName="item" key={item.item_id}>
      <p className="heavy_text">
        { tr('matching.rental_history.date_range', {
          from: item.from.format(dateFormat),
          to: getToDate(item.to)
        }) }
      </p>
      <p className="text top_margin_16">
        { tr('matching.rental_history.address_format', {
          country: mapIsoCodeToCountryName(item.country),
          street_and_building: item.address,
          postal_code: item.postal_code,
          city: item.city,
          region: item.region
        })}
      </p>
    </div>
  ));
}

function RentalHistory({ asSharedProfile, firstTimeMover, history }) {
  return (
    <PanelWithTitleAndIcon icon={rentalHistoryIcon} title={title(asSharedProfile)}>
      { getHistoryItems(firstTimeMover, history) }
    </PanelWithTitleAndIcon>
  );
}

RentalHistory.propTypes = {
  asSharedProfile: PropTypes.bool,
  firstTimeMover: PropTypes.bool.isRequired,
  history: ImmutablePropTypes.listOf(HistoryItem.propType).isRequired
};

RentalHistory.defaultProps = {
  asSharedProfile: false
};

export default RentalHistory;
